// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tabs":"tabs-3idEFt2J","current":"current-2y8oRCZU","item":"item-3Z5MaHMj","dot":"dot-8fAelVtO"};